import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const FinalCtaSection = () => {
  const navigate = useNavigate();

  return (
    <section 
      className="py-16 sm:py-24 text-center relative overflow-hidden border-t border-[#E2E8F0]"
      style={{ background: 'linear-gradient(180deg, #F0FAF8 0%, #FFFFFF 100%)' }}
    >
      <motion.div 
        initial={{ opacity: 0, y: 25 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-[1200px] mx-auto px-4 sm:px-6 md:px-8 relative z-10"
      >
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-[46px] font-extrabold text-[#0F172A] tracking-tight max-w-[720px] mx-auto mb-3 sm:mb-4" style={{ lineHeight: '1.45' }}>
          Join the businesses<br />
          <span className="text-[#067978]">travellers are already looking for.</span>
        </h2>
        <p className="text-[#334155] font-medium text-xs sm:text-base md:text-[17px] max-w-[520px] mx-auto mb-8 sm:mb-10">
          Free to list. Live in 10 minutes. No risk, no upfront cost.
        </p>
        <motion.button 
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            navigate('/signup');
          }}
          className="px-6 sm:px-9 py-3.5 sm:py-4 bg-[#067978] hover:bg-[#044E4D] text-white font-bold text-xs sm:text-base rounded-xl shadow-lg hover:shadow-xl transition-all inline-flex items-center gap-2 cursor-pointer border-none"
        >
          List your business free <i className="ti ti-arrow-right"></i>
        </motion.button>
      </motion.div>
    </section>
  );
};

export default FinalCtaSection;
